import { GOOGLE_TAG_CONSTANTS } from 'constants/googleTagConstants'

function resumeTestSuccess(props, allTestStatus, param) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.TAP_RESUME_TEST_WEB,
        'User comes back to the test after being logged out and clicks on the resume test button',
        {
            success: true,
            user_test_id: allTestStatus[param]['userTestId'],
        },
    )
}

function resumeTestFailure(props, allTestStatus, param, error) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.TAP_RESUME_TEST_WEB,
        'User comes back to the test after being logged out and clicks on the resume test button',
        {
            failure: true,
            reason_for_failure: error,
            user_test_id: allTestStatus[param]['userTestId'],
        },
    )
}

function startTestSuccess(props, res) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.TAP_START_TEST_WEB,
        'Usertaps on start test button',
        {
            success: true,
            user_test_id: res.data.userTestId,
        },
    )
}

function startTestFailure(props, error) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.TAP_START_TEST_WEB,
        'Usertaps on start test button',
        {
            failure: true,
            reason_for_failure: error,
            user_test_id:
                'testStatus' in props.testStatus
                    ? props?.testStatus?.testStatus?.data.userTestId
                    : null,
        },
    )
}

function pageLoadSuccess(props, instructionsData) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.INSTRUCTION_LANDING_WEB,
        'User lands on the instruction page of the test',
        {
            success: true,
            user_test_id:
                'testStatus' in props.testStatus
                    ? props.testStatus?.testStatus?.data?.userTestId
                    : null,
        },
    )
}

export {
    startTestSuccess,
    startTestFailure,
    resumeTestSuccess,
    resumeTestFailure,
    pageLoadSuccess,
}
